import { render } from "./OtherServicesSidebar.vue?vue&type=template&id=601aaa50&ts=true"
import script from "./OtherServicesSidebar.vue?vue&type=script&lang=ts"
export * from "./OtherServicesSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__